import React, { ReactNode } from 'react'
import classNames from 'classnames'
import { t } from '../../i18n'

export type AdjustmentMode = 'add' | 'remove'

const ADJUSTMENT_MODES: AdjustmentMode[] = ['add', 'remove']

const scope = 'stock_control.plate_container'

export const parseBowlAmount = (passedValue: string | number): number | null => {
  const value = passedValue ? parseInt(`${passedValue}`) : 0

  return isNaN(value) ? null : Math.max(0, value)
}

interface Props {
  remainingAmount: number,
  maxAmount: number,
  newTotal: number,
  amount: number,
  onAmountChange: (value: string) => void,
  mode: AdjustmentMode,
  // Without it the form is add-only and the Add/Remove tabs are left out.
  onModeChange?: (mode: AdjustmentMode) => void,
  notice?: ReactNode,
  error: string | null,
  onCancel: () => void,
  onSave: () => void,
  saveDisabled: boolean,
}

const BowlStandForm = ({
  remainingAmount, maxAmount, newTotal, amount, onAmountChange, mode, onModeChange,
  notice, error, onCancel, onSave, saveDisabled
}: Props) => {
  const showsNewTotal = amount > 0 && !error

  return (
    <div className='container-modal edit'>
      <div className='plate-stand-status'>
        <span className='plate-stand-status-label'>{t('in_stand', { scope })}</span>
        <span className='plate-stand-status-amount'>
          <span>{remainingAmount}</span>
          {showsNewTotal && <span className='plate-stand-status-preview'>{` → ${newTotal}`}</span>}
          <span>{` / ${maxAmount}`}</span>
        </span>
      </div>
      {notice}
      {onModeChange &&
        <div className='amount-mode-tabs'>
          {ADJUSTMENT_MODES.map(tabMode =>
            <button
              key={tabMode}
              type='button'
              className={classNames('amount-mode-tab', { active: mode === tabMode })}
              onClick={() => onModeChange(tabMode)}
            >
              {t(tabMode, { scope })}
            </button>
          )}
        </div>
      }
      <div className='plate-stand-field'>
        <span className='input-label'>{t(mode === 'add' ? 'amount_to_add' : 'amount_to_remove', { scope })}</span>
        {/* No stepper here: the tabs already carry the direction, so a minus
            beside them reads as a second, contradictory way to remove bowls. */}
        <input
          className='plate-stand-amount-input'
          type='text'
          inputMode='numeric'
          value={amount}
          maxLength={3}
          onChange={({ target: { value } }) => onAmountChange(value)}
        />
      </div>
      {error && <div className='plate-stand-error'>{error}</div>}
      <div className='buttons'>
        <button className='btn btn-secondary' onClick={onCancel}>{t('cancel')}</button>
        <button className='btn btn-primary' onClick={onSave} disabled={saveDisabled}>{t('save')}</button>
      </div>
    </div>
  )
}

export default BowlStandForm
